// This serves as a reference for field name values, it's used to ensure any update to `FormValues`
// is reflected in field names in the rest of the files.
export const messengerSettingsFormFields = {
    title: 'title',
    description: 'description',
    startConversation: 'startConversation',
    findArticles: 'findArticles',
    backgroundColor: 'backgroundColor',
    bulletinBoardEnabled: 'bulletinBoardEnabled',
    bulletinBoardId: 'bulletinBoardId',
    availableLocales: 'availableLocales',
    logo: 'logo',
    launcherIconType: 'launcherIconType',
    defaultLanguage: 'defaultLanguage',
    minimumIdentificationLevel: 'minimumIdentificationLevel',
};
